import { defineComponent } from 'vue';
export default defineComponent({
    name: 'JobCheckStepFinal',
    props: { email: String, finalStepInfoText: String },
});
